// extracted by mini-css-extract-plugin
export default {"Header":"AboutUs_Header__gI5R1","HeaderInner":"AboutUs_HeaderInner__XJFWh","HeaderText":"AboutUs_HeaderText__jCd3e","Cards":"AboutUs_Cards__1dZgz","Card":"AboutUs_Card__zIRNh"};